module.exports = __webpack_public_path__ + "static/media/cd.264d62d3.svg";